import ReconnectingWebSocket from 'reconnecting-websocket';
import jwt_decode from "jwt-decode";
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useHome } from '../screens/Home/hooks/useHome';


const server = 'wss://cy9jtdo2b4.execute-api.us-east-1.amazonaws.com/v1';


export const useWebSocket = () => {
    const { refreshToken, notificationsSocket, setNotificationsSocket } = useContext(AuthContext)

    const generateAction = async (event) => {
        switch (event) {
            case 'REFRESH_TOKEN':
                await refreshToken();
                break;

            default:
                break;
        }
    }


    const webSocketConnection = async () => {
        let directoryId = JSON.parse(localStorage.getItem("tokenDecoded"))?.directoryId
        let typeOfDirectoryId = JSON.parse(localStorage.getItem("tokenDecoded"))?.typeOfDirectoryId

        while (directoryId == null && typeOfDirectoryId == null) {
            await new Promise(resolve => setTimeout(resolve, 3000));
            directoryId = JSON.parse(localStorage.getItem("tokenDecoded"))?.directoryId ? JSON.parse(localStorage.getItem("tokenDecoded")).directoryId : null
            typeOfDirectoryId = JSON.parse(localStorage.getItem("tokenDecoded"))?.typeOfDirectoryId ? JSON.parse(localStorage.getItem("tokenDecoded")).typeOfDirectoryId : null
        }

        const message = { directoryId, typeOfDirectoryId, deviceInfo: null };

        const rws = new ReconnectingWebSocket(server);

        rws.addEventListener('open', (event) => {
            rws.send(JSON.stringify(message));
        });

        rws.addEventListener('message', async (event) => {
            await handleWebSocketMessage(event);
        });

        return rws;

    }

    const handleWebSocketMessage = async (notification) => {
        let jsonNotification = JSON.parse(notification.data);
        let event = jsonNotification;
        console.log("even",event)
        setNotificationsSocket(event)
        await generateAction(event.messageType);
    }

    return {
        webSocketConnection
    }

}
